/* Arbuckle product page (arb-pdp-* sections): gallery, option/plan/quantity
   state, add to cart (Rebuy Smart Cart / theme drawer), sticky bar, "pairs
   well with" quick add and Stamped-powered reviews. No dependencies. Safe to
   load more than once. */
(function () {
  'use strict';
  if (window.ArbPdp) return;

  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- money ---------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    cents = Number(cents) || 0;
    format = format || '${{amount}}';
    function delim(n, prec, th, dec) {
      var parts = (n / 100).toFixed(prec).split('.');
      return parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + th) + (parts[1] ? dec + parts[1] : '');
    }
    var m = format.match(/\{\{\s*(\w+)\s*\}\}/);
    var key = m ? m[1] : 'amount', val;
    switch (key) {
      case 'amount_no_decimals': val = delim(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': val = delim(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': val = delim(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': val = delim(cents, 2, "'", '.'); break;
      default: val = delim(cents, 2, ',', '.');
    }
    return format.replace(/\{\{\s*\w+\s*\}\}/, val);
  }

  function svg(name) {
    var p = {
      check: '<path d="m5 12.5 4.6 4.6L19.2 7.4"/>',
      arrow: '<path d="M5 12h14M13 6l6 6-6 6"/>',
      verified: '<path d="m12 2.9 2.3 1.6 2.8-.1.9 2.6 2.3 1.6-.8 2.7.8 2.7-2.3 1.6-.9 2.6-2.8-.1L12 21.1l-2.3-1.6-2.8.1-.9-2.6-2.3-1.6.8-2.7-.8-2.7L6 8.6l.9-2.6 2.8.1L12 2.9Z"/><path d="m8.9 12.1 2.1 2.1 4.1-4.2"/>'
    }[name] || '';
    return '<svg class="arb-pdp-ico" viewBox="0 0 24 24" aria-hidden="true" focusable="false" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round">' + p + '</svg>';
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* ---------- cart helpers (Rebuy Smart Cart -> theme drawer -> cart page) ---------- */
  function cartRoot() { return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'; }
  function refreshCart() {
    try { document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { source: 'arb-pdp' } })); } catch (e) {}
    var R = window.Rebuy;
    try { if (R && R.Cart && typeof R.Cart.fetchCart === 'function') R.Cart.fetchCart(); } catch (e) {}
  }
  function showCart() {
    var R = window.Rebuy;
    if (R && R.SmartCart && typeof R.SmartCart.show === 'function') {
      var f = null;
      try { if (R.Cart && typeof R.Cart.fetchCart === 'function') f = R.Cart.fetchCart(); } catch (e) {}
      Promise.resolve(f).catch(function () {}).then(function () { try { R.SmartCart.show(); } catch (e) {} });
      return;
    }
    var d = document.querySelector('cart-drawer');
    if (d && typeof d.renderContents === 'function' && document.getElementById('CartDrawer')) {
      fetch(cartRoot() + '?sections=cart-drawer,cart-icon-bubble').then(function (r) { return r.json(); })
        .then(function (sections) { d.renderContents({ sections: sections }); })
        .catch(function () { window.location.href = cartRoot() + 'cart'; });
      return;
    }
    window.location.href = cartRoot() + 'cart';
  }
  function addItems(items) {
    return fetch(cartRoot() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Could not add to cart'); return j; });
    });
  }

  /* ---------- shared scroll loop (one listener for every instance) ---------- */
  var scrollers = [];
  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      ticking = false;
      scrollers.forEach(function (fn) { fn(); });
    });
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });

  /* ==========================================================================
     Product main
     ========================================================================== */
  function Pdp(root) {
    this.root = root;
    var raw = $('[data-arb-pdp-data]', root);
    try { this.d = JSON.parse(raw.textContent); } catch (e) { return; }
    this.p = this.d.product;
    this.form = $('[data-form]', root);
    this.rc = $('[data-arb-rc]', root);
    this.fmt = this.d.moneyFormat;
    var p = this.p;

    // Current selection from the server-rendered state.
    var idInput = $('[data-id-input]', root);
    var startId = Number(idInput && idInput.value);
    this.v = p.variants.filter(function (x) { return x.id === startId; })[0] || p.variants[0];
    this.opts = (this.v.options || []).slice();
    var modeChecked = $('input[name^="ArbMode-"]:checked', root);
    this.mode = modeChecked ? modeChecked.value : 'once';
    var planChecked = $('[data-plan-radio]:checked', root);
    this.planId = planChecked ? Number(planChecked.value) : null;
    var qtyChecked = $('input[name^="ArbQty-"]:checked', root);
    var qtyInput = $('[data-qty-input]', root);
    this.qty = qtyChecked ? Number(qtyChecked.value) : (qtyInput ? Number(qtyInput.value) || 1 : 1);
    this.addedSig = null;

    // Choices carried over by a link such as "Review your subscription" on the subscribe page:
    // ?variant= is applied by Shopify; ?selling_plan=, ?qty= and ?purchase=once are applied here.
    // Shown inside another page (the landing page's product view), they come from the host's data-arb-qs,
    // variant included, and the page's address is left alone.
    var host = root.closest('[data-arb-qs]');
    this.hosted = !!host;
    try {
      var qs = new URLSearchParams(host ? host.getAttribute('data-arb-qs') : window.location.search);
      var qv = Number(qs.get('variant'));
      var hv = host && qv ? p.variants.filter(function (x) { return x.id === qv; })[0] : null;
      if (hv) { this.v = hv; this.opts = (hv.options || []).slice(); }
      var qp = parseInt(qs.get('qty'), 10);
      if (qp >= 1 && qp <= 99) this.qty = qp;
      var sp = Number(qs.get('selling_plan'));
      if (sp && (this.v.selling_plan_allocations || []).some(function (x) { return x.selling_plan_id === sp; })) { this.planId = sp; this.mode = 'sub'; }
      if (qs.get('purchase') === 'once') this.mode = 'once';
      var modeRadio = $('input[name^="ArbMode-"][value="' + this.mode + '"]', root);
      if (modeRadio) modeRadio.checked = true;
    } catch (e) {}

    this.bindGallery();
    this.bindOptions();
    this.bindBar();
    this.render();
  }

  /* ---------- gallery ---------- */
  Pdp.prototype.bindGallery = function () {
    var self = this, root = this.root;
    var track = $('[data-track]', root);
    if (!track) return;
    var slides = $$('[data-slide]', track);
    var thumbs = $$('[data-thumb]', root);
    var frame = $('[data-frame]', root);
    var prev = $('[data-prev]', root), next = $('[data-next]', root);
    this.g = { track: track, slides: slides, thumbs: thumbs, frame: frame, i: 0 };

    function setActive(i) {
      if (i === self.g.i && frame.getAttribute('data-ready')) return;
      var old = slides[self.g.i];
      if (old && old !== slides[i]) self.stopVideo(old);
      self.g.i = i;
      frame.setAttribute('data-ready', '1');
      var s = slides[i];
      frame.setAttribute('data-type', s ? s.getAttribute('data-type') : '');
      frame.classList.toggle('is-fill', !!(s && s.classList.contains('is-fill')));
      thumbs.forEach(function (t, k) {
        var on = k === i;
        t.classList.toggle('is-active', on);
        if (on) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current');
      });
      if (prev) prev.disabled = i <= 0;
      if (next) next.disabled = i >= slides.length - 1;
      var th = thumbs[i];
      if (th && th.parentNode.scrollWidth > th.parentNode.clientWidth) {
        th.parentNode.scrollTo({ left: th.offsetLeft - 12, behavior: reduce ? 'auto' : 'smooth' });
      }
    }
    this.goTo = function (i) {
      i = Math.max(0, Math.min(slides.length - 1, i));
      track.scrollTo({ left: i * track.clientWidth, behavior: reduce ? 'auto' : 'smooth' });
      setActive(i);
    };
    var raf = null;
    track.addEventListener('scroll', function () {
      if (raf) return;
      raf = requestAnimationFrame(function () {
        raf = null;
        var w = track.clientWidth || 1;
        setActive(Math.round(track.scrollLeft / w));
      });
    }, { passive: true });
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { self.goTo(Number(t.getAttribute('data-thumb'))); });
    });
    if (prev) prev.addEventListener('click', function () { self.goTo(self.g.i - 1); });
    if (next) next.addEventListener('click', function () { self.goTo(self.g.i + 1); });
    track.addEventListener('keydown', function (e) {
      if (e.target !== track) return;
      if (e.key === 'ArrowRight') { e.preventDefault(); self.goTo(self.g.i + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); self.goTo(self.g.i - 1); }
    });
    $$('[data-video]', track).forEach(function (btn) {
      btn.addEventListener('click', function () { self.playVideo(btn.closest('[data-slide]')); });
    });
    setActive(0);
  };

  Pdp.prototype.playVideo = function (slide) {
    var btn = $('[data-video]', slide);
    if (!btn) return;
    var src = btn.getAttribute('data-video');
    var tpl = $('template[data-video-tpl]', slide);
    var node;
    if (tpl) {
      node = tpl.content.firstElementChild.cloneNode(true);
    } else if (src) {
      node = document.createElement('iframe');
      node.src = src;
      node.title = btn.getAttribute('aria-label') || 'Product video';
      node.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
      node.setAttribute('allowfullscreen', '');
    }
    if (!node) return;
    node.setAttribute('data-video-live', '');
    btn.hidden = true;
    slide.appendChild(node);
    if (node.tagName === 'VIDEO' && node.play) { try { node.play(); } catch (e) {} }
  };
  Pdp.prototype.stopVideo = function (slide) {
    var live = $('[data-video-live]', slide);
    if (!live) return;
    live.remove();
    var btn = $('[data-video]', slide);
    if (btn) btn.hidden = false;
  };

  /* ---------- options / quantity / plans ---------- */
  Pdp.prototype.bindOptions = function () {
    var self = this, root = this.root;
    $$('[data-opt]', root).forEach(function (fs) {
      var idx = Number(fs.getAttribute('data-opt'));
      $$('input[type="radio"]', fs).forEach(function (inp) {
        inp.addEventListener('change', function () {
          if (!inp.checked) return;
          self.opts[idx] = inp.value;
          self.pickVariant(idx);
        });
      });
    });
    $$('input[name^="ArbQty-"]', root).forEach(function (inp) {
      inp.addEventListener('change', function () { if (inp.checked) { self.qty = Number(inp.value) || 1; self.render(); } });
    });
    $$('input[name^="ArbMode-"]', root).forEach(function (inp) {
      inp.addEventListener('change', function () { if (inp.checked) { self.mode = inp.value; self.render(); } });
    });
    $$('[data-plan-radio]', root).forEach(function (inp) {
      inp.addEventListener('change', function () { if (inp.checked) { self.planId = Number(inp.value); self.setMode('sub'); } });
    });
    var sub = $('[data-plan-card="sub"]', root);
    if (sub) {
      sub.addEventListener('click', function (e) {
        if (self.mode === 'sub' || e.target.closest('[data-plan-radio]')) return;
        self.setMode('sub');
      });
    }
    if (this.form) {
      this.form.addEventListener('submit', function (e) {
        e.preventDefault();
        var atc = $('[data-atc]', root);
        if (atc && atc.classList.contains('is-added')) showCart(); else self.add();
      });
    }
  };

  Pdp.prototype.setMode = function (m) {
    var r = $('input[name^="ArbMode-"][value="' + m + '"]', this.root);
    if (r) r.checked = true;
    this.mode = m;
    this.render();
  };

  Pdp.prototype.pickVariant = function (idx) {
    var opts = this.opts;
    var match = this.p.variants.filter(function (v) {
      return v.options.every(function (o, i) { return o === opts[i]; });
    })[0];
    if (!match) {
      // That combination doesn't exist: keep the option just picked and get as close as
      // possible on the rest ("Whole bean" vs "Whole Bean" counts as nearly the same),
      // then move the other tiles so the selection shown is the variant being priced.
      var norm = function (s) { return String(s).toLowerCase().replace(/\s+/g, ' ').trim(); };
      var best = -1;
      this.p.variants.forEach(function (v) {
        if (idx != null && v.options[idx] !== opts[idx]) return;
        var s = v.available ? 0.05 : 0;
        v.options.forEach(function (o, i) { if (o === opts[i]) s += 1; else if (norm(o) === norm(opts[i])) s += 0.9; });
        if (s > best) { best = s; match = v; }
      });
      if (match) this.opts = match.options.slice();
    }
    if (match) this.v = match;
    if (match && !this.hosted && window.history && window.history.replaceState) {
      try {
        var u = new URL(window.location.href);
        u.searchParams.set('variant', match.id);
        window.history.replaceState({}, '', u.toString());
      } catch (e) {}
    }
    this.render();
  };

  Pdp.prototype.alloc = function () {
    var a = (this.v && this.v.selling_plan_allocations) || [];
    if (!a.length) return null;
    var id = this.planId;
    return a.filter(function (x) { return x.selling_plan_id === id; })[0] || a[0];
  };

  Pdp.prototype.plan = function (id) {
    var found = null;
    (this.p.selling_plan_groups || []).forEach(function (g) {
      (g.selling_plans || []).forEach(function (pl) { if (pl.id === id) found = pl; });
    });
    return found;
  };
  Pdp.prototype.planName = function (id) { var pl = this.plan(id); return pl ? pl.name : ''; };
  // "Delivery every 4 weeks ..." -> { n: 4, unit: 'week', days: 28 }
  Pdp.prototype.planInterval = function (id) {
    var pl = this.plan(id);
    if (!pl) return null;
    var src = (pl.options || []).map(function (o) { return o.value; }).concat([pl.name || '']);
    for (var i = 0; i < src.length; i++) {
      var m = /(\d+)\s*-?\s*(day|week|month)/i.exec(String(src[i]));
      if (m) { var n = +m[1], u = m[2].toLowerCase(); return { n: n, unit: u, days: n * (u === 'day' ? 1 : u === 'week' ? 7 : 30) }; }
    }
    return null;
  };

  // the plan Recharge's widget lists for this frequency, else the product's own (the same Recharge plan)
  Pdp.prototype.sellingPlan = function (a) {
    var iv = this.planInterval(a.selling_plan_id);
    return (window.ArbRecharge && window.ArbRecharge.plan(this.rc, a.selling_plan_id, iv && iv.days)) || a.selling_plan_id;
  };

  Pdp.prototype.unit = function () {
    var a = this.alloc();
    return this.mode === 'sub' && a ? a.price : this.v.price;
  };
  Pdp.prototype.sig = function () {
    var a = this.alloc();
    return [this.v.id, this.mode === 'sub' && a ? a.selling_plan_id : 'once', this.qty].join('|');
  };

  Pdp.prototype.render = function () {
    var self = this, root = this.root, v = this.v, d = this.d, fmt = this.fmt;
    if (!v) return;
    var a = this.alloc();
    var hasPlans = !!a;
    if (!hasPlans && this.mode === 'sub') this.mode = 'once';
    if (a && this.planId !== a.selling_plan_id) this.planId = a.selling_plan_id;
    var sub = this.mode === 'sub';
    var unit = this.unit();
    var total = unit * this.qty;
    var pct = a && a.compare_at_price > a.price ? Math.round((a.compare_at_price - a.price) * 100 / a.compare_at_price) : 0;
    var unitOne = d.unitOne || 'bag', unitMany = d.unitMany || 'bags';

    // hidden inputs
    var idIn = $('[data-id-input]', root); if (idIn) idIn.value = v.id;
    var qIn = $('[data-qty-input]', root); if (qIn) qIn.value = this.qty;
    var pIn = $('[data-plan-input]', root);
    if (pIn) { pIn.value = sub && a ? this.sellingPlan(a) : ''; pIn.disabled = !(sub && a); }
    // keep the hidden Recharge widget on this variant
    if (window.ArbRecharge && this.rc) window.ArbRecharge.mount(this.rc, this.p.id, v.id);

    // option tiles: selection + availability
    $$('[data-opt]', root).forEach(function (fs) {
      var idx = Number(fs.getAttribute('data-opt'));
      $$('.arb-pdp__tile', fs).forEach(function (tile) {
        var inp = $('input', tile);
        var on = inp.value === self.opts[idx];
        inp.checked = on;
        tile.classList.toggle('is-on', on);
        var probe = self.opts.slice(); probe[idx] = inp.value;
        var avail = self.p.variants.some(function (x) {
          return x.available && x.options.every(function (o, i) { return o === probe[i]; });
        });
        tile.classList.toggle('is-out', !avail);
        var out = $('[data-out]', tile); if (out) out.hidden = avail;
      });
      var cur = $('[data-opt-current]', fs);
      if (cur) cur.textContent = String(self.opts[idx] || '').split(' (')[0];
    });

    // price row
    var now = $('[data-now]', root); if (now) now.textContent = formatMoney(unit, fmt);
    var was = $('[data-was]', root);
    if (was) { was.innerHTML = '<span class="arb-pdp-vh">Regular price </span>' + esc(formatMoney(v.price, fmt)); was.hidden = !(sub && pct > 0); }
    var save = $('[data-save]', root); if (save) { save.textContent = 'Save ' + pct + '%'; save.hidden = !(sub && pct > 0); }
    var cmp = $('[data-cmp]', root);
    if (cmp) { cmp.hidden = sub || !(v.compare_at_price > v.price); if (v.compare_at_price) cmp.textContent = formatMoney(v.compare_at_price, fmt); }
    var per = $('[data-per]', root); if (per) per.textContent = 'per ' + unitOne + (sub && pct > 0 ? ', subscribed' : '');

    // plan cards
    var plans = $('[data-plans]', root);
    if (plans) plans.hidden = !hasPlans;
    var onceCard = $('[data-plan-card="once"]', root), subCard = $('[data-plan-card="sub"]', root);
    if (onceCard) onceCard.classList.toggle('is-on', !sub);
    if (subCard) subCard.classList.toggle('is-on', sub);
    // the cards show totals for the chosen number of bags (matching the add-to-cart button), per-bag price underneath for 2+
    var q = this.qty;
    var oncePrice = $('[data-once-price]', root); if (oncePrice) oncePrice.textContent = formatMoney(v.price * q, fmt);
    var subPrice = $('[data-sub-price]', root); if (subPrice && a) subPrice.textContent = formatMoney(a.price * q, fmt);
    var subWas = $('[data-sub-was]', root); if (subWas) { subWas.textContent = formatMoney(v.price * q, fmt); subWas.hidden = !(pct > 0); }
    var subUnit = $('[data-sub-unit]', root); if (subUnit && a) { subUnit.textContent = formatMoney(a.price, fmt) + '/' + unitOne; subUnit.hidden = q < 2; }
    var onceUnit = $('[data-once-unit]', root); if (onceUnit) { onceUnit.textContent = formatMoney(v.price, fmt) + '/' + unitOne; onceUnit.hidden = q < 2; }
    var subPct = $('[data-sub-pct]', root); if (subPct) { subPct.textContent = 'Save ' + pct + '%'; subPct.hidden = !(pct > 0); }
    if (a) {
      var allowed = (v.selling_plan_allocations || []).map(function (x) { return x.selling_plan_id; });
      // every schedule the same price: show the note; otherwise each schedule's price on its button
      var prices = {};
      (v.selling_plan_allocations || []).forEach(function (x) { prices[x.selling_plan_id] = x.price; });
      var same = (v.selling_plan_allocations || []).every(function (x) { return x.price === a.price; });
      var fnote = $('[data-freq-note]', root); if (fnote) fnote.hidden = !same;
      $$('[data-plan-radio]', root).forEach(function (r) {
        r.disabled = allowed.indexOf(Number(r.value)) === -1;
        r.checked = Number(r.value) === a.selling_plan_id;
        r.tabIndex = sub ? 0 : -1;
        var pp = $('[data-plan-price]', r.parentNode), pr = prices[Number(r.value)];
        if (pp) { pp.textContent = pr != null ? formatMoney(pr, fmt) : ''; pp.hidden = same || pr == null; }
      });
      var iv = this.planInterval(a.selling_plan_id);
      var nextEl = $('[data-next-order]', root);
      if (nextEl) {
        if (iv) {
          var dt = new Date(); dt.setDate(dt.getDate() + iv.days);
          var ds = dt.toLocaleDateString(undefined, { month: 'short', day: 'numeric' });
          $('[data-next-order-text]', nextEl).innerHTML = 'Next order around <b>' + esc(ds) + '</b>, then every ' + iv.n + ' ' + iv.unit + (iv.n === 1 ? '' : 's') + '.';
          nextEl.hidden = false;
        } else nextEl.hidden = true;
      }
    }

    // quantity tiers
    $$('.arb-pdp__tier', root).forEach(function (tier) {
      var inp = $('input', tier), q = Number(inp.value);
      var on = q === self.qty;
      inp.checked = on;
      tier.classList.toggle('is-on', on);
      var tp = $('[data-tier-price]', tier); if (tp) tp.textContent = formatMoney(unit * q, fmt);
      var flag = $('[data-flag]', tier);
      if (flag) {
        var custom = flag.getAttribute('data-custom') || '';
        var txt = custom;
        if (!txt && d.freeShip > 0 && unit * q >= d.freeShip) txt = d.freeShipFlag || '';
        flag.textContent = txt;
        flag.hidden = !txt;
      }
    });
    var qc = $('[data-qty-current]', root);
    if (qc) qc.textContent = this.qty + ' ' + (this.qty === 1 ? unitOne : unitMany);

    // low stock vs eyebrow
    var inv = d.inventory ? d.inventory[String(v.id)] : null;
    var low = inv !== null && inv !== undefined && inv > 0 && d.lowStock > 0 && inv <= d.lowStock;
    var lowEl = $('[data-low]', root), eb = $('[data-eyebrow]', root);
    if (lowEl) {
      lowEl.hidden = !low;
      if (low) $('[data-low-text]', lowEl).textContent = 'Only ' + inv + ' left in ' + this.optSummary();
    }
    if (eb) eb.hidden = low;

    // add to cart (after an add, the button reads "View cart" until the selection changes)
    var atc = $('[data-atc]', root);
    var bb = this.bar && $('[data-bar-add]', this.bar);
    if (this.addedSig && this.addedSig !== this.sig()) {
      this.addedSig = null;
      [atc, bb].forEach(function (b) { if (b) b.classList.remove('is-added'); });
    }
    var added = !!this.addedSig;
    if (atc && !atc.classList.contains('is-busy')) {
      atc.disabled = !v.available && !added;
      if (added) {
        $('[data-atc-label]', atc).innerHTML = '<span class="arb-pdp__atc-ico">' + svg('check') + '</span>' + esc(d.viewCartLabel || 'View cart');
        var ap0 = $('[data-atc-price]', atc); ap0.innerHTML = '<span class="arb-pdp__atc-ico">' + svg('arrow') + '</span>'; ap0.hidden = false;
      } else {
        $('[data-atc-label]', atc).textContent = v.available ? (d.atcLabel || 'Add to cart') : 'Sold out';
        var ap = $('[data-atc-price]', atc); ap.textContent = formatMoney(total, fmt); ap.hidden = !v.available;
      }
      var dot = $('[data-atc-dot]', atc); if (dot) dot.hidden = !v.available || added;
    }
    var note = $('[data-atc-note]', root); if (note) note.hidden = !sub;

    // sticky bar
    var bar = this.bar;
    if (bar) {
      var sum = $('[data-bar-sum]', bar);
      var planTxt = sub && a ? this.planName(a.selling_plan_id).replace(/^Delivery /i, '').replace(/ with .*$/i, '') : 'One-time';
      if (sum) sum.textContent = [this.optSummary(), this.qty + ' ' + (this.qty === 1 ? unitOne : unitMany), planTxt].filter(Boolean).join(' · ');
      var bp = $('[data-bar-price]', bar); if (bp) bp.textContent = formatMoney(total, fmt);
      if (bb && !bb.classList.contains('is-busy')) {
        bb.disabled = !v.available && !added;
        bb.textContent = added ? (d.viewCartLabel || 'View cart') : (v.available ? (d.atcLabel || 'Add to cart') : 'Sold out');
      }
    }
  };

  Pdp.prototype.optSummary = function () {
    var p = this.p, self = this;
    return (p.options || []).map(function (o, i) {
      var vals = o.values || [];
      return vals.length > 1 ? String(self.opts[i] || '').split(' (')[0] : '';
    }).filter(Boolean).join(' · ');
  };

  /* ---------- add to cart ---------- */
  Pdp.prototype.add = function (fromBar) {
    var self = this, root = this.root, v = this.v;
    var atc = $('[data-atc]', root), bb = this.bar && $('[data-bar-add]', this.bar);
    if (!v || !v.available || (atc && atc.classList.contains('is-busy'))) return;
    var a = this.alloc();
    var item = { id: v.id, quantity: this.qty };
    if (this.mode === 'sub' && a) item.selling_plan = this.sellingPlan(a);
    var err = $('[data-err]', root); if (err) { err.hidden = true; err.textContent = ''; }
    [atc, bb].forEach(function (b) { if (!b) return; b.classList.add('is-busy'); b.setAttribute('aria-busy', 'true'); });
    if (atc) $('[data-atc-label]', atc).textContent = 'Adding…';
    if (bb) bb.textContent = 'Adding…';
    addItems([item]).then(function () {
      [atc, bb].forEach(function (b) { if (!b) return; b.classList.remove('is-busy'); b.removeAttribute('aria-busy'); b.classList.add('is-added'); });
      self.addedSig = self.sig();
      var live = $('[data-live]', root); if (live) live.textContent = self.p.title + ' added to cart. Press View cart to see your cart.';
      self.render();
      refreshCart();
    }).catch(function (e) {
      [atc, bb].forEach(function (b) { if (!b) return; b.classList.remove('is-busy'); b.removeAttribute('aria-busy'); });
      self.render();
      if (err) { err.textContent = e.message || 'Something went wrong. Please try again.'; err.hidden = false; }
      if (fromBar && atc) atc.scrollIntoView({ block: 'center', behavior: reduce ? 'auto' : 'smooth' });
    });
  };

  /* ---------- sticky bar ---------- */
  Pdp.prototype.bindBar = function () {
    var self = this, bar = $('[data-bar]', this.root);
    this.bar = bar;
    if (!bar) return;
    // Portal to <body> so no ancestor stacking context can trap it.
    document.body.appendChild(bar);
    var btn = $('[data-bar-add]', bar);
    if (btn) btn.addEventListener('click', function () { if (btn.classList.contains('is-added')) showCart(); else self.add(true); });
    var atc = $('[data-atc]', this.root);
    // inside another page's product view there's no site footer to stay clear of
    var footer = this.hosted ? null : document.querySelector('.shopify-section-group-footer-group, footer');
    this.check = function () {
      if (!atc || !document.body.contains(self.root)) return;
      var r = atc.getBoundingClientRect();
      var passed = r.bottom < 0;
      var nearFoot = footer ? footer.getBoundingClientRect().top < window.innerHeight : false;
      var drawerOpen = document.documentElement.classList.contains('rebuy-cart-visible') ||
        document.body.classList.contains('overflow-hidden') || document.body.classList.contains('rebuy-cart-visible');
      var on = passed && !nearFoot && !drawerOpen;
      if (on === bar.classList.contains('is-on')) return;
      bar.classList.toggle('is-on', on);
      bar.setAttribute('aria-hidden', on ? 'false' : 'true');
      if (on) bar.removeAttribute('inert'); else bar.setAttribute('inert', '');
    };
    scrollers.push(this.check);
    this.check();
  };

  Pdp.prototype.destroy = function () {
    var i = scrollers.indexOf(this.check);
    if (i > -1) scrollers.splice(i, 1);
    if (this.bar && this.bar.parentNode) this.bar.parentNode.removeChild(this.bar);
  };

  /* ==========================================================================
     Pairs well with: one-click add (one-time purchase, first available variant)
     ========================================================================== */
  function Pairs(root) {
    var live = $('[data-pairs-live]', root);
    $$('[data-pair-add]', root).forEach(function (btn) {
      var label = btn.textContent;
      btn.addEventListener('click', function () {
        if (btn.classList.contains('is-added')) { showCart(); return; }
        if (btn.classList.contains('is-busy')) return;
        btn.classList.add('is-busy'); btn.setAttribute('aria-busy', 'true'); btn.textContent = 'Adding…';
        addItems([{ id: Number(btn.getAttribute('data-pair-add')), quantity: 1 }]).then(function () {
          btn.classList.remove('is-busy'); btn.removeAttribute('aria-busy'); btn.classList.add('is-added');
          btn.innerHTML = svg('check') + '<span>View cart</span>';
          if (live) live.textContent = (btn.getAttribute('data-title') || 'Item') + ' added to cart.';
          refreshCart();
        }).catch(function (e) {
          btn.classList.remove('is-busy'); btn.removeAttribute('aria-busy'); btn.textContent = label;
          if (live) live.textContent = e.message || 'Could not add to cart.';
        });
      });
    });
  }

  /* ==========================================================================
     Reviews (Stamped public widget API, this product only)
     ========================================================================== */
  function Reviews(root) {
    this.root = root;
    this.key = root.getAttribute('data-key');
    this.store = root.getAttribute('data-store');
    this.pid = root.getAttribute('data-product-id');
    this.handle = root.getAttribute('data-handle');
    this.take = Number(root.getAttribute('data-take')) || 6;
    this.page = 0;
    this.total = 0;
    this.seen = {};
    this.list = $('[data-list]', root);
    this.more = $('[data-more]', root);
    this.status = $('[data-status]', root);
    var self = this;
    if (!this.key || !this.pid) { this.fail(); return; }
    if (this.more) this.more.addEventListener('click', function () { self.load(); });
    var start = function () { if (self.started) return; self.started = true; self.loadBars(); self.load(); };
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        if (es.some(function (e) { return e.isIntersecting; })) { io.disconnect(); start(); }
      }, { rootMargin: '700px 0px' });
      io.observe(root);
    } else { start(); }
  }

  Reviews.prototype.api = function (path) {
    return 'https://stamped.io/api/' + path + (path.indexOf('?') > -1 ? '&' : '?') +
      'apiKey=' + encodeURIComponent(this.key) + '&storeUrl=' + encodeURIComponent(this.store);
  };

  Reviews.prototype.loadBars = function () {
    var self = this, bars = $('[data-bars]', this.root);
    if (!bars) return;
    fetch('https://stamped.io/api/widget/badges?isIncludeBreakdown=true&isincludehtml=false', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ productIds: [{ productId: String(self.pid), productSku: self.handle }], apiKey: self.key, storeUrl: self.store })
    }).then(function (r) { if (!r.ok) throw 0; return r.json(); }).then(function (j) {
      var b = j && j[0] && j[0].breakdown;
      if (!b) return;
      var sum = 0, s;
      for (s = 1; s <= 5; s++) sum += Number(b['rating' + s]) || 0;
      if (!sum) return;
      $$('[data-star]', bars).forEach(function (li) {
        var n = Number(b['rating' + li.getAttribute('data-star')]) || 0;
        $('[data-n]', li).textContent = n.toLocaleString('en-US');
        var fill = $('[data-fill]', li);
        fill.style.setProperty('--w', '0%');
        requestAnimationFrame(function () { requestAnimationFrame(function () { fill.style.setProperty('--w', (n * 100 / sum).toFixed(1) + '%'); }); });
      });
      bars.hidden = false;
    }).catch(function () {});
  };

  Reviews.prototype.load = function () {
    var self = this;
    if (this.busy) return;
    this.busy = true;
    if (this.more) { this.more.disabled = true; this.more.textContent = 'Loading…'; }
    var next = this.page + 1;
    var url = this.api('widget/reviews?productId=' + encodeURIComponent(this.pid) + '&take=' + this.take + '&page=' + next + '&minRating=1&sortReviews=recent');
    fetch(url).then(function (r) { if (!r.ok) throw 0; return r.json(); }).then(function (j) {
      self.busy = false;
      self.page = next;
      self.total = Number(j.total) || 0;
      if (next === 1) self.list.innerHTML = '';
      var added = 0;
      (j.data || []).forEach(function (rv) {
        var k = [rv.author, rv.reviewDate, rv.reviewMessage].join('|');
        if (self.seen[k]) return;
        self.seen[k] = 1;
        self.list.appendChild(self.card(rv));
        added++;
      });
      self.list.setAttribute('aria-busy', 'false');
      if (next === 1 && !added) { self.status.textContent = 'No reviews yet.'; }
      var more = self.page * self.take < self.total;
      if (self.more) { self.more.hidden = !more; self.more.disabled = false; self.more.textContent = 'Show more reviews'; }
      if (next > 1 && added) self.status.textContent = 'Loaded ' + added + ' more reviews.';
    }).catch(function () {
      self.busy = false;
      if (self.page === 0) self.fail();
      else if (self.more) { self.more.disabled = false; self.more.textContent = 'Try again'; }
    });
  };

  Reviews.prototype.fail = function () {
    if (this.list) { this.list.innerHTML = ''; this.list.setAttribute('aria-busy', 'false'); }
    if (this.status) this.status.textContent = 'Reviews could not load right now. Please refresh to try again.';
    if (this.more) this.more.hidden = true;
  };

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text !== undefined && text !== null) n.textContent = text;
    return n;
  }
  function plain(html) {
    var t = document.createElement('div');
    t.innerHTML = String(html || '').replace(/<br\s*\/?>/gi, '\n');
    return (t.textContent || '').trim();
  }
  var MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  function niceDate(s) {
    var m = String(s || '').match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);
    return m ? MONTHS[Number(m[1]) - 1] + ' ' + Number(m[2]) + ', ' + m[3] : String(s || '');
  }

  Reviews.prototype.card = function (rv) {
    var c = el('article', 'arb-pdp-rv__card');
    var rating = Math.max(0, Math.min(5, Number(rv.reviewRating) || 0));
    var top = el('div', 'arb-pdp-rv__card-top');
    var stars = el('span', 'arb-pdp-stars');
    stars.style.setProperty('--arb-pdp-fill', (rating * 20) + '%');
    stars.setAttribute('role', 'img');
    stars.setAttribute('aria-label', 'Rated ' + rating + ' out of 5');
    var five = '★★★★★';
    var off = el('span', 'arb-pdp-stars__off', five); off.setAttribute('aria-hidden', 'true');
    var on = el('span', 'arb-pdp-stars__on', five); on.setAttribute('aria-hidden', 'true');
    stars.appendChild(off); stars.appendChild(on);
    top.appendChild(stars);
    if (rv.reviewDate) top.appendChild(el('span', 'arb-pdp-rv__date', niceDate(rv.reviewDate)));
    c.appendChild(top);
    var title = plain(rv.reviewTitle);
    if (title) c.appendChild(el('h3', 'arb-pdp-rv__title', title));
    var body = el('p', 'arb-pdp-rv__body', plain(rv.reviewMessage));
    body.style.whiteSpace = 'pre-line';
    c.appendChild(body);
    var reply = plain(rv.reviewReply);
    if (reply) {
      var rp = el('div', 'arb-pdp-rv__reply');
      rp.appendChild(el('b', '', 'Arbuckle Coffee replied'));
      rp.appendChild(document.createTextNode(reply));
      c.appendChild(rp);
    }
    var who = el('div', 'arb-pdp-rv__who');
    var name = String(rv.author || 'Customer').trim();
    var av = el('span', 'arb-pdp-rv__av', name.charAt(0).toUpperCase()); av.setAttribute('aria-hidden', 'true');
    who.appendChild(av);
    var nm = el('span', 'arb-pdp-rv__name', name);
    var meta = el('span', 'arb-pdp-rv__meta');
    if (Number(rv.reviewVerifiedType) === 2) {
      var ver = el('span', 'arb-pdp-rv__ver');
      ver.innerHTML = svg('verified');
      ver.appendChild(document.createTextNode('Verified buyer'));
      meta.appendChild(ver);
    }
    if (rv.location) meta.appendChild(el('span', '', rv.location));
    if (meta.childNodes.length) nm.appendChild(meta);
    who.appendChild(nm);
    c.appendChild(who);
    return c;
  };

  /* ==========================================================================
     Boot + theme editor support
     ========================================================================== */
  var instances = [];
  function init(scope) {
    $$('[data-arb-pdp]', scope).forEach(function (root) {
      if (root.__arbPdp) return;
      root.__arbPdp = new Pdp(root);
      instances.push(root.__arbPdp);
    });
    $$('[data-arb-reviews]', scope).forEach(function (root) {
      if (root.__arbRv) return;
      root.__arbRv = new Reviews(root);
    });
    $$('[data-arb-pairs]', scope).forEach(function (root) {
      if (root.__arbPairs) return;
      root.__arbPairs = new Pairs(root);
    });
  }
  document.addEventListener('shopify:section:unload', function (e) {
    var root = e.target && e.target.querySelector && e.target.querySelector('[data-arb-pdp]');
    if (root && root.__arbPdp && root.__arbPdp.destroy) root.__arbPdp.destroy();
  });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });

  // destroy(scope) tears down product pages inside scope (sticky bar, scroll hook); refresh() re-checks
  // the sticky bars when the page scrolls inside an overlay rather than the window.
  function destroy(scope) {
    $$('[data-arb-pdp]', scope).forEach(function (root) {
      if (root.__arbPdp && root.__arbPdp.destroy) root.__arbPdp.destroy();
      instances = instances.filter(function (x) { return x !== root.__arbPdp; });
    });
  }
  window.ArbPdp = { init: init, destroy: destroy, refresh: onScroll, formatMoney: formatMoney };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
})();
